<template>
  <div class="comment-editor">
    <div class="comments-wrap">
      <ul :class="{'comment-thread':true, 'has-comments': sortedComments.length > 0 ? true : false}">
        <SocialPostComment v-for="comment in sortedComments" :socialPost="socialPost" :comment="comment" :commentField="commentField" :key="comment.id" @clickReply="replyToComment" :namespace="namespace" />
      </ul>
    </div>
    <div class="comment-input-wrap">
      <b-collapse v-model="showReply" class="reply-collapse">
        <div class="reply-label">{{ replyComment.name }} - {{ replyDate }}</div>
        <span class="reply-text">{{ replyText }}</span>
        <i class="fas fa-times" @click="hideReply"></i>
      </b-collapse>
      <textarea rows="1" :name="`comment-post-${socialPost.id}`" v-model="commentText" class="comment-input" ref="commentInput" placeholder="Type a new message" @input="$event => resizeInput($event.target)" :disabled="commentDisabled"
	      @keydown.enter.exact.prevent
        @keyup.enter.exact="commentSubmitted"
        @keydown.enter.shift.exact="newline"
      	></textarea>
      <div class="comment-controls">
        <b-button @click="commentSubmitted" :id="`comment-post-${socialPost.id}`" class="comment-button" :disabled="commentButtonDisabled">
          <i class="fas fa-paper-plane"></i>
        </b-button>
        <emoji-picker @emoji="insertEmoji" :search="emojiSearch" class="emoji-picker-outer">
          <button class="emoji-invoker" slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }" @click.stop="clickEvent">
            <!--<button type="button">Open</button>-->
            <i class="far fa-smile"></i>
          </button>
          <div class="emoji-picker" slot="emoji-picker" slot-scope="{ emojis, insert, display }">
            <div class="emoji-search-wrap">
              <input type="text" placeholder="Search Emoji" v-model="emojiSearch">
            </div>
            <div class="emoji-list-wrap">
              <div class="emoji-category" v-for="(emojiGroup, category) in emojis" :key="category">
                <h5>{{ category }}</h5>
                <div class="emoji-category-content">
                  <span
                    v-for="(emoji, emojiName) in emojiGroup"
                    :key="emojiName"
                    @click="insertEmoji(emoji)"
                    :title="emojiName"
                  >{{ emoji }}</span>
                </div>
              </div>
            </div>
          </div>
        </emoji-picker>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ref from "vue";
import SocialPostComment from "./SocialPostComment.vue";
import EmojiPicker from 'vue-emoji-picker';

import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      commentText: "",
      commentDisabled: false,
      submittingComment: false,
      emojiSearch: "",
      emojiInput: "",
      showReply: false,
      replyComment: false,
      dateFormat: "MMMM Do YYYY, h:mm a",
    };
  },
  components: {
    SocialPostComment,
    EmojiPicker,
  },
  props: ["socialPost", "commentField", "namespace"],
  computed: {
    ...mapState({
      deliverableDetail(state, getters) {
        return getters[this.namespace + 'deliverableDetail']
      },
      loggedInUserData(state, getters) {
        return getters[this.namespace + 'loggedInUserData']
      },
    }),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    sortedComments(){
      let comments = this.socialPost.comments;
      let filteredComments = comments.filter((el) => el.field_name == this.commentField)
      return _.orderBy(filteredComments, function(el){
        return new moment(el.created_at)
      }).reverse();
    },
    commentButtonDisabled(){
      if(!this.commentText.length || this.submittingComment){
        return true;
      }
      return false;
    },
    replyText(){
      if(this.replyComment){
        let text = this.replyComment.comments;
        if(text.length > 50){
          text = truncateString(text, 50);
        }
        return text;
      }
      return "";
    },
    replyDate(){
      if(this.replyComment){
        return this.$moment.utc(this.replyComment.created_at).local().format(this.dateFormat);
      }
      return "";
    }
  },
  methods: {
  	 newline() {
      this.commentText = `${this.commentText}`;
    },
    commentSubmitted(e){
      if(!this.commentText.length){
        //console.log("Comment must not be empty.");
      } else {
        this.submittingComment = true;
        this.commentDisabled = true;
        let that = this;
        let parentId = null;
        if(this.showReply && this.replyComment){
          parentId = this.replyComment.id;
        }
        that.$store.dispatch(that.namespace + "createSocialPostComment", {
          id: that.socialPost.id,
          parent_comment_id: parentId,
          field_name: that.commentField,
          comments: that.commentText
        }).then(function(){
          that.initializeCommentEditor();
          that.showReply = false;
        });
      }
      
    },
    resizeInput(textArea){
      textArea.style.height = "5px";
      textArea.style.height = (textArea.scrollHeight)+"px";
    },
    filterByField(comment){
      if(comment.field_name == this.commentField){
        return true;
      }
      return false;
    },
    getInitials(name){
      let names = name.split(" ");
      let initials = "";
      names.forEach(function(el){
        initials += el.charAt(0);
      });
      return initials;
    },
    getReplyText(commentId){
      let commentText = this.socialPost.comments.filter((el) => el.id == commentId)[0].comments;
      if(commentText.length>50){
        commentText = truncateString(commentText, 50);
      }
      return commentText;
    },
    initializeCommentEditor(){
      this.commentText = "";
      this.commentDisabled = false;
      this.submittingComment = false;
    },
    insertEmoji(emoji){
      this.commentText += emoji;
    },
    replyToComment(comment){
      this.replyComment = comment;
      this.showReply = true;
			this.$nextTick(() => {
	      this.$refs.commentInput.focus();
	    });
    },
    hideReply(){
      this.showReply = false;
    }
  },
  created(){
    this.initializeCommentEditor();
  },
}
</script>